/* eslint-disable */
import Select from "react-select"; // Import react-select for multi-select UI.
import { reactSelectStyle } from "Config/Config"; // Import centralized operators.

const MultiSelectField = ({
  label,
  options,
  value,
  onChange,
  isMulti = true,
  placeholder,
  onInputChange,
}) => {
  return (
    <div className="form-group mb-3 mb-sm-4">
      <label className="d-block fs-sm fw-semibold mb-2">{label}</label>
      <Select
        isMulti={isMulti}
        placeholder={placeholder}
        styles={reactSelectStyle("2px", "6px", true, false)}
        options={options}
        value={value}
        onChange={onChange}
        onInputChange={onInputChange}
      />
    </div>
  );
};

export default MultiSelectField;
